<script>
  import SendCardOverpanel from '../SendCardOverpanel/SendCardOverpanel.svelte';
  import { emailCard } from '../../utils/send-card';

  let {
    title,
    instructionLabelText,
    inputPlaceholder,
    inputValidationMessage,
    disclaimer,
    submitButtonText,
    successMessage,
    closeButtonText,
    errorMessage,
    errorInstruction,
    retryButtonText,
    card = {},
    query = {},
    lang,
    categories,
  } = $props();
</script>

<SendCardOverpanel
  {title}
  {instructionLabelText}
  {inputPlaceholder}
  {inputValidationMessage}
  {disclaimer}
  {submitButtonText}
  {successMessage}
  {closeButtonText}
  {errorMessage}
  {errorInstruction}
  {retryButtonText}
  {card}
  {query}
  {lang}
  {categories}
  overpanelKey="emailCard"
  inputType="email"
  sendCardService={emailCard}
  successIconName="email"
  data-testid="email-card-overpanel"
/>
